import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  ReloadIcon,
  TgBlackIcon,
  UnderMaintenanceBgImg,
  DogUnderMaintenanceImg
} from "@/assets"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import "./style.scss"

interface IAppOld {
  currVer?: string
  yourVer?: string
}

export const AppOld: FC<IAppOld> = ({ currVer, yourVer }) => {
  const { t, i18n } = useTranslation()

  const handleOpenNews = () => {
    const linkToOpen =
      i18n.language === "ru"
        ? "https://t.me/labrador_labr_ru"
        : "https://t.me/labrador_labr"

    if (!import.meta.env.DEV) {
      window.Telegram.WebApp.openTelegramLink(linkToOpen)
    } else {
      window.open(linkToOpen, "_blank")
    }
  }

  return (
    <div
      id="app-old-version"
      className="fullscreen"
      style={{ backgroundImage: `url(${UnderMaintenanceBgImg})` }}
    >
      <Container
        className="wrapper"
        triangleTopPosLeft="80%"
        triangleBottomPosLeft="31px"
      >
        <h1>{t("appOldVersion.h1")}</h1>
        <h2>{t("appOldVersion.h2.0")}</h2>
        <div className="divider"></div>
        <h2>
          {t("appOldVersion.version.latest")}: v{currVer}
          <br />
          {t("appOldVersion.version.your")}: v{yourVer}
        </h2>
        <div className="buttons">
          <Button onClick={handleOpenNews}>
            <TgBlackIcon width={16} height={16} />
            {t("appOldVersion.readNews")}
          </Button>
          <Button
            onClick={() => {
              // @ts-ignore
              window.location.reload(true)
            }}
          >
            {t("appOldVersion.refresh")}
            <ReloadIcon width={20} height={20} />
          </Button>
        </div>
      </Container>
      <img className={clsx("dog")} src={DogUnderMaintenanceImg} alt="dog" />
    </div>
  )
}
